import {Component, Input, OnInit} from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {ActivatedRoute, NavigationEnd, Router, RouterLink, RouterModule} from "@angular/router";
import {MainStoreService} from "@cybfed/core/store/main.store.service";
import {CommonModule } from "@angular/common";
import {UserStore} from "@cybfed/core/store/user.store";
import {PageBuilderStore} from "@white-label/components/page-builder/page-builder.store";
import {
    SideBarMenuComponent
} from "@white-label/components/page-builder/components/headers/components/side-bar-menu/side-bar-menu.component";
import {
    NavigationComponent
} from "@white-label/components/page-builder/components/headers/components/navigation/navigation.component";
import {
    HeaderActionsComponent
} from "@white-label/components/page-builder/components/headers/components/actions/header-actions.component";
import {
    LoggedInMenuComponent
} from "@white-label/components/page-builder/components/headers/components/logged-in/logged-in-menu.component";

@Component({
  selector: 'white-label-default-header',
    templateUrl: './default-header.component.html',
    standalone: true,
    imports: [
        TranslateModule,
        RouterLink,
        RouterModule,
        CommonModule,
        SideBarMenuComponent,
        NavigationComponent,
        HeaderActionsComponent,
        LoggedInMenuComponent,
    ],
    providers: [
  ]
})
export class DefaultHeaderComponent implements OnInit{
    @Input() editMode: boolean = false;

    shown: boolean = false;
    componentData: any;
    whiteLabel: any;
    platformAdminRole: any;
    currentUrl: string = '';
    currentSlug: any
    inPageBuilderPage = false

    constructor(
                public mainStoreService: MainStoreService,
                public pageBuilderStore: PageBuilderStore,
                public route: ActivatedRoute,
                public router: Router,
                public userStore: UserStore) {
        if(this.userStore?.currentUser?.whiteLabels){
            let roleIndex = this.userStore?.currentUser.whiteLabels.findIndex(l => l.whiteLabelId == this.userStore?.currentUser?.whiteLabelId);
            if(roleIndex >= 0){
                this.platformAdminRole = this.userStore?.currentUser?.whiteLabels[roleIndex].role
            }
        }
        this.whiteLabel = this.mainStoreService.whiteLabel

        this.currentUrl = this.router.url;


        // // Use a regular expression to extract the slug from the URL
        const slugMatch = this.currentUrl.match(/p\/([^\/]+)/);
        if (slugMatch && slugMatch[1]) {
            this.currentSlug = slugMatch[1]; // Extract slug from URL
        }
        if (this.currentUrl.includes('page-builder')) {
            this.inPageBuilderPage = true
        }

    }

    ngOnInit() {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.currentUrl = event.url;
                const slugMatch = this.currentUrl.match(/p\/([^\/]+)/);
                if (slugMatch && slugMatch[1]) {
                    this.currentSlug = slugMatch[1];
                }
                if (this.currentUrl.includes('page-builder')) {
                    this.inPageBuilderPage = true
                }
            }
        });
    }

    isActive(url: string): boolean {
        return this.currentUrl === url;
    }

    closeMenu(): boolean {
        return this.shown = !this.shown;
    }

    menuNavigation(value: string){
        if (this.inPageBuilderPage && this.currentSlug) {
            this.router.navigate(['page-builder/' + value])
        }else {
            this.router.navigate([value])
        }

    }
}


